// @flow
export { default } from './AnnotationActivity';
